import { useSyncExternalStore } from 'react';

const QUERY = '(prefers-reduced-motion: reduce)';

const getMediaQueryList = () =>
    typeof window !== 'undefined' && typeof window.matchMedia === 'function'
        ? window.matchMedia(QUERY)
        : null;

const subscribe = (callback: () => void) => {
    const mql = getMediaQueryList();
    if (!mql?.addEventListener) {
        return () => {};
    }
    mql.addEventListener('change', callback);
    return () => mql.removeEventListener('change', callback);
};

const getSnapshot = () => getMediaQueryList()?.matches === true;

/**
 * Tracks the user's `prefers-reduced-motion` setting, updating if it changes.
 * Returns `false` during SSR and in environments without `matchMedia`.
 */
export const usePrefersReducedMotion = () =>
    useSyncExternalStore(subscribe, getSnapshot, () => false);
